// extracted by mini-css-extract-plugin
export default {"wrapper":"Ripple_wrapper__9+l7g","ink":"Ripple_ink__6spI0","inkActive":"Ripple_inkActive__U2kY8","ripple":"Ripple_ripple__0gubl"};